import instance from "../api/instance";
import { logout } from "./sessionActions";
import { queryString, getFilters } from "../../components/utils/functions";
import {
  GET_REPORT_TYPES,
  GET_REPORT_CONTENT,
  CLEAR_REPORT_CONTENT,
} from "../constants/constants";

export const reportType = () => {
  return (dispatch) => {
    return instance
      .get(`/reports/report-types`)
      .then((response) => {
        dispatch({
          type: GET_REPORT_TYPES,
          reportTypes: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const downloadReport = (
  reportType,
  type,
  landscape = false,
  filters = []
) => {
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "search", value: searchFilters }];

  var query = searchFilters !== "" ? `?${queryString(queryFilters)}` : "";

  return (dispatch) => {
    return instance
      .get(`/reports/${reportType}/type/${type}/landscape/${landscape}${query}`)
      .then((response) => {
        return response.data.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getReportData = (
  reportType,
  userType,
  page = 0,
  size = 10,
  filters = [],
  bsc = false
) => {
  const searchFilters = getFilters(filters);
  const queryFilters = [{ property: "search", value: searchFilters }];

  const query =
    searchFilters !== ""
      ? `&${queryString(queryFilters)}${!bsc ? "" : "isReportBsc_"}`
      : "";

  const url = `/reports/${reportType}/${userType}?page=${page}&size=${size}${
    reportType === "BILLS" ? `&sort=id,DESC` : ``
  }${query}`;

  return (dispatch) => {
    return instance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_REPORT_CONTENT,
          content: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const clearReportData = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_REPORT_CONTENT,
    });
  };
};
